// 2026-05-30 Global error banner — full-width, bright red, sticky at the
// top of the page, IMPOSSIBLE to miss. Mounted in AppLayout above everything.

import { useState } from 'react';
import { useErrorBus, errorBus } from '../lib/errorBus';

export default function GlobalErrorBanner() {
  const errors = useErrorBus();
  const [expanded, setExpanded] = useState<Set<number>>(new Set());

  if (errors.length === 0) return null;

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0,
      zIndex: 999999, display: 'flex', flexDirection: 'column',
      pointerEvents: 'none',
    }}>
      {errors.map((e) => {
        const isOpen = expanded.has(e.id);
        const bg = e.severity === 'fatal' ? '#dc2626' : '#f59e0b';
        const accent = e.severity === 'fatal' ? '#7f1d1d' : '#92400e';
        return (
          <div
            key={e.id}
            style={{
              background: bg, color: '#fff',
              borderBottom: `3px solid ${accent}`,
              padding: '10px 16px',
              boxShadow: '0 4px 12px rgba(0,0,0,0.25)',
              display: 'flex', alignItems: 'flex-start', gap: 12,
              fontSize: 14, fontWeight: 600,
              pointerEvents: 'auto',
              animation: 'fferr-pulse 1.2s ease-in-out 2',
            }}
            role="alert"
          >
            <div style={{ fontSize: 18, lineHeight: 1.2 }}>
              {e.severity === 'fatal' ? '🔴' : '⚠️'}
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: 14, fontWeight: 700, lineHeight: 1.3 }}>
                {e.title}
              </div>
              {e.detail && !isOpen && (
                <button
                  onClick={() => setExpanded((s) => new Set(s).add(e.id))}
                  style={{
                    marginTop: 4, background: 'transparent', color: '#fff',
                    border: '1px solid rgba(255,255,255,0.55)',
                    borderRadius: 3, padding: '2px 8px',
                    fontSize: 11, fontWeight: 600, cursor: 'pointer',
                  }}
                >show details ▾</button>
              )}
              {e.detail && isOpen && (
                <pre style={{
                  marginTop: 6, padding: '8px 10px',
                  background: 'rgba(0,0,0,0.25)', borderRadius: 4,
                  whiteSpace: 'pre-wrap', wordBreak: 'break-word',
                  fontSize: 11, fontWeight: 400, lineHeight: 1.45,
                  maxHeight: 260, overflow: 'auto',
                }}>{e.detail}</pre>
              )}
              <div style={{ fontSize: 10, opacity: 0.85, marginTop: 4 }}>
                source: {e.source} · {new Date(e.ts).toLocaleTimeString()}
              </div>
            </div>
            <button
              onClick={() => errorBus.dismiss(e.id)}
              aria-label="Dismiss"
              title="Dismiss"
              style={{
                background: 'transparent', color: '#fff', border: 'none',
                fontSize: 22, lineHeight: 1, cursor: 'pointer', padding: '0 6px',
              }}
            >×</button>
          </div>
        );
      })}
      <style>{`@keyframes fferr-pulse {
        0%   { transform: translateY(-3px); }
        50%  { transform: translateY(0); }
        100% { transform: translateY(0); }
      }`}</style>
    </div>
  );
}
